const fieldsVisibility = {
  minExpertVotes: ["mudaraba", "musharaka"],
  issuerCommision: ["mudaraba"],
  hasEscrow: ["invest", "mudaraba", "musharaka"]
};

export default function isFieldVisible(fieldName, context) {
  return fieldsVisibility[fieldName]?.includes(context) || false;
}